import CarouselLinks from 'shared/assets/scripts/carouselLinks'

export default class TagList {
	private tagList: HTMLElement | null
	private isDesktop: boolean

	constructor() {
		this.tagList = document.querySelector('.tagList')
		this.isDesktop = window.matchMedia('(min-width: 1000px)').matches
	}

	init() {
		if (this.isDesktop && this.tagList) {
			const carouselLinks = new CarouselLinks(this.tagList)
			carouselLinks.init()
		}
	}
}
